webpackJsonp([114276838955818,60335399758886],{

/***/ 109:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Blog by George Montgomery","siteTwitterUrl":"https://twitter.com/Adverbly_","siteLinkedInUrl":"https://www.linkedin.com/in/montgomerygeorge","siteGithubUrl":"https://github.com/Adverbly/Adverbly.github.io","siteEmailUrl":"mailto:george.p.montgomery@gmail.com"}}},"layoutContext":{}}

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(224);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(109);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	    return _react2.default.createElement(
	        "footer",
	        { id: "footer" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "ul",
	                { className: "icons" },
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: props.data.site.siteMetadata.siteTwitterUrl, className: "icon alt fa-twitter" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "label" },
	                            "Twitter"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: props.data.site.siteMetadata.siteEmailUrl, className: "icon alt fa-envelope" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "label" },
	                            "Email"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: props.data.site.siteMetadata.siteGithubUrl, className: "icon alt fa-github" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "label" },
	                            "GitHub"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                        "a",
	                        { href: props.data.site.siteMetadata.siteLinkedInUrl, className: "icon alt fa-linkedin" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "label" },
	                            "LinkedIn"
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "ul",
	                { className: "copyright" },
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "\xA9 Untitled"
	                ),
	                _react2.default.createElement(
	                    "li",
	                    null,
	                    "Design: ",
	                    _react2.default.createElement(
	                        "a",
	                        { href: "https://html5up.net" },
	                        "HTML5 UP"
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(107);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	    return _react2.default.createElement(
	        'header',
	        { id: 'header', className: 'alt' },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', className: 'logo' },
	            _react2.default.createElement(
	                'span',
	                null,
	                'I want to go home'
	            )
	        )
	    );
	};
	
	Header.propTypes = {
	    onToggleMenu: _react2.default.PropTypes.func
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(408);
	
	var _Header = __webpack_require__(223);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(222);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	    _inherits(Template, _React$Component);
	
	    function Template(props) {
	        _classCallCheck(this, Template);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            isMenuVisible: false,
	            loading: 'is-loading'
	        };
	        _this.handleToggleMenu = _this.handleToggleMenu.bind(_this);
	        return _this;
	    }
	
	    Template.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        this.timeoutId = setTimeout(function () {
	            _this2.setState({ loading: '' });
	        }, 100);
	    };
	
	    Template.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.timeoutId) {
	            clearTimeout(this.timeoutId);
	        }
	    };
	
	    Template.prototype.handleToggleMenu = function handleToggleMenu() {
	        this.setState({
	            isMenuVisible: !this.state.isMenuVisible
	        });
	    };
	
	    Template.prototype.render = function render() {
	        var children = this.props.children;
	
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'body ' + this.state.loading + ' ' + (this.state.isMenuVisible ? 'is-menu-visible' : '') },
	            _react2.default.createElement(
	                'div',
	                { id: 'wrapper' },
	                _react2.default.createElement(_Header2.default, { onToggleMenu: this.handleToggleMenu, data: this.props.data }),
	                children(),
	                _react2.default.createElement(_Footer2.default, { data: this.props.data })
	            )
	        );
	    };
	
	    return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	    children: _react2.default.PropTypes.func
	};
	
	exports.default = Template;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-70d4dbeb7e79c78b779a.js